import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'
import FileSaver from 'file-saver';
import OPERATION_CATEGORY from '../enums/OperationCategoryEnum';
import OPERATION_ACTIVITY from "../enums/OperationActivityEnum";
import T from 'i18n-react';

class OperationService {

    /**
     * Permet de récupérer la liste des opérations à un instant T pour un shop I et un financement Y
     * @param {*String} date : Date qui correspond à la funding date
     * @param {*Long} idShop : Id du magasin souhaité (si pas d'id on récupère l'ensemble des magasins associé à l'utilisateur)
     * @param {*String} financingDate : Date qui correspond à la date de création -> Date de financement ( utilisé pour le cas où on a plusieurs financeent )
     * @param idBu
     * @param streamType
     * @param cardTypes
     * @param activities
     * @param detailsDateTransaction
     */
    getOperationListFromDate(date, idShop, financingDate, idBu, streamType, cardTypes, activities, detailsDateTransaction) {
        let url = '/api/operation?localDate=' + date + '&detailsDateTransaction=' + detailsDateTransaction;
        if (idShop) {
            url += '&idShop=' + idShop
        }

        if (financingDate !== null && financingDate !== undefined && (!Array.isArray(financingDate) || financingDate.length !== 0)) {
            url += '&createDate=' + financingDate
        }

        if (idBu) {
            url += '&idBu=' + idBu
        }

        if (streamType && streamType.code) {
            url += '&streamType=' + streamType.code
        }

        if (cardTypes && cardTypes.length > 0) {
            url += '&cards=' + cardTypes;
        }

        if (activities && activities.length > 0) {
            url += '&activities=' + activities;
        }

        return WebService.call(url, HttpMethods.GET, null)
    }


    /**
     * Récupére la liste des opérations en fonction de la période
     * @param beginDate
     * @param endDate
     * @param idShop
     * @param idBu
     * @param streamType
     * @param cardTypes
     * @param activities
     * @param detailsDateTransaction
     * @return {*}
     */
    getOperationListFromPeriod(beginDate, endDate, idShop, idBu, streamType, cardTypes, activities, detailsDateTransaction) {
        let url = '/api/operation/periodic?startLocalDate=' + beginDate + '&endLocalDate=' + endDate + '&detailsDateTransaction=' + detailsDateTransaction;
        if (idShop) {
            url += '&idShop=' + idShop;
        }
        if (idBu) {
            url += '&idBu=' + idBu;
        }
        if (streamType && streamType.code) {
            url += '&streamType=' + streamType.code;
        }
        if (cardTypes && cardTypes.length > 0) {
            url += '&cards=' + cardTypes;
        }
        if (activities && activities.length > 0) {
            url += '&activities=' + activities;
        }

        return WebService.call(url, HttpMethods.GET, null);
    }

    getAllCardTypes() {
        let url = '/api/operation/cardTypes';
        return WebService.call(url, HttpMethods.GET, null);
    }

    getAllCardActivities() {
        let url = '/api/operation/activities';
        return WebService.call(url, HttpMethods.GET, null);
    }

    /**
     * Permet de récupérer le block associé aux opérations du tableau 
     * @param {*List} idblockList : Liste d'id block
     * @param {*String} financingDate : Case multi financement
     */
    getCodaBlock(idblockList, financingDate) {
        let url = '/api/operation/block?'

        // Si on a pas d'idBlock on ne fait pas d'appel
        if (!idblockList || idblockList.length === 0) {
            return
        }

        if(financingDate) {
            url += 'createDate=' + financingDate
        }
        const data = {
            'idBlockList': idblockList
        };

        return WebService.call(url, HttpMethods.POST, data)
    }

    /**
     * Permet de récupérer la last funding date d'une bu ou d'un shop
     * @param {*} idBu 
     * @param {*} idShop 
     */
    getLastFundingDate(idBu, idShop) {
        // Il ne peut pas avoir un idShop & un idBu
        var url = '/api/operation/lastfundingdate?idBu=' + idBu;
        
        if(idShop) {
            url += `&idShop=${idShop}`
        }

        return WebService.call(url, HttpMethods.GET)
    }

    /**
     * Permet de télécharge le PDF
     * @param fundingDate
     * @param idBu
     * @param idShop
     * @param financingDate
     * @param callback
     */
    getPDF(fundingDate, idBu, idShop, financingDate, streamType, cardTypes, activities, detailsDateTransaction, callback) {
        let url = '/api/operation/pdf?fundingDate=' + fundingDate + '&detailsDateTransaction=' + detailsDateTransaction;
        if (idShop) {
            url += '&idShop=' + idShop;
        }
        if (idBu) {
            url += '&idBu=' + idBu;
        }
        if (financingDate) {
            url += '&createDate=' + financingDate;
        }
        if (streamType) {
            url += '&streamType=' + streamType.code;
        }
        if (cardTypes && cardTypes.length > 0) {
            url += '&cards=' + cardTypes;
        }
        if (activities && activities.length > 0) {
            url += '&activities=' + activities;
        }

        WebService.downloadFile(url, HttpMethods.GET, function (blob, fileName) {
            FileSaver.saveAs(blob, fileName);
            callback(true);
        });
    }

    /**
     * Permet de télécharge le PDF pour le tableau periodic
     * @param startLocalDate
     * @param endLocalDate
     * @param idShop
     * @param idBu
     * @param streamType
     * @param cardTypes
     * @param activities
     * @param detailsDateTransaction
     * @param callback
     */
    getPeriodicPDF(startLocalDate, endLocalDate, idShop, idBu, streamType, cardTypes, activities, detailsDateTransaction, callback) {
        let url = '/api/operation/periodic/pdf?startLocalDate=' + startLocalDate + '&endLocalDate=' + endLocalDate + '&detailsDateTransaction=' + detailsDateTransaction;
        if (idShop) {
            url += '&idShop=' + idShop;
        }
        if (idBu) {
            url += '&idBu=' + idBu;
        }
        if (streamType) {
            url += '&streamType=' + streamType.code;
        }
        if (cardTypes && cardTypes.length > 0) {
            url += '&cards=' + cardTypes;
        }
        if (activities && activities.length > 0) {
            url += '&activities=' + activities;
        }

        WebService.downloadFile(url, HttpMethods.GET, function (blob, fileName) {
            FileSaver.saveAs(blob, fileName);
            callback(true);
        });
    }

    /**
     * Récupére les opérations non relié a un magasin
     */
    getNotLinkOperationList(jobType) {
        return WebService.call('/api/operation/notlink?jobType=' + jobType, HttpMethods.GET)
    }

    getDefaultSortOperationDefaultFunction() {
        return function (a, b) {
            //On met les operations de processing fees à la fin
            if (a.category === OPERATION_CATEGORY.PROCESSING_FEES) {
                return 1;
            }
            if (b.category === OPERATION_CATEGORY.PROCESSING_FEES) {
                return -1;
            }
            if (a.contractNumber === b.contractNumber && a.tradeDate && b.tradeDate) {
                if (a.tradeDate === b.tradeDate) {
                    if (a.operationType) {
                        return a.operationType > b.operationType ? 1 : -1;
                    }
                    if (a.cardType) {
                        return a.cardType > b.cardType ? 1 : -1;
                    }
                }
                // trie par date
                let dateA = new Date().createFrenchDate(a.tradeDate)
                let dateB = new Date().createFrenchDate(b.tradeDate)
                return dateA > dateB ? 1 : -1;
            }
            return a.contractNumber > b.contractNumber ? 1 : -1;
        }
    }

    getDataActivity (data) {
        let activityDataTransformed = {
            text: '',
            hover: ''
        };
        if(data.category !== OPERATION_CATEGORY.PROCESSING_FEES){
            if (data.category === OPERATION_CATEGORY.UNPAID_FRA) {
                const unpaidPrefix = T.translate('table.unpaid') + ": ";
                activityDataTransformed.text += unpaidPrefix;
                activityDataTransformed.hover += unpaidPrefix;
            }
            if(data.activity) {
                const activityKey = this.getActivityKey(data.activity);
                if (activityKey) {
                    activityDataTransformed.hover += OPERATION_ACTIVITY[activityKey].label;
                    activityDataTransformed.text += OPERATION_ACTIVITY[activityKey].code;
                } else {
                    activityDataTransformed.hover += data.activity;
                    activityDataTransformed.text += data.activity;
                }
            }
        }
        return activityDataTransformed;
    }

    getActivityKey(activity){
        const activityKey = Object.keys(OPERATION_ACTIVITY).find(key => OPERATION_ACTIVITY[key].data === activity.toLocaleLowerCase());
        if(activityKey){
            return activityKey;
        } else {
            return null;
        }
    }
}

export default new OperationService();


// WEBPACK FOOTER //
// ./src/services/OperationService.js